import axios from 'axios'
import router from '@/router'
import {
	MessageBox,
	Message
} from 'element-ui'
import store from '@/store'
import {
	getToken
} from './auth.js'
// create an axios instance
const service = axios.create({
	baseURL: process.env.NODE_ENV == 'development' ? '/api' : process.env.VUE_APP_BASE_API,
	timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		if (store.getters.token) {
			config.headers.token = getToken()
		}
		return config
	},
	error => {
		// do something with request error
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		const res = response.data
		if (res.code !== 200 && res.code !== 3004 && res.code !== 3001) {
			Message({
				message: res.msg || 'Error',
				type: 'error',
				duration: 5 * 1000
			})

			// if(res.code == 3001){
			// 	router.replace('/404')
			// }

			if (res.code === 1002 || res.code === 1003 || res.code === 1004) {
				store.dispatch('user/resetToken').then(() => {
					location.reload()
				})
			}
			return Promise.reject(res || 'Error')
		} else {
			return res
		}
	},
	error => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

export default service
